import type { Payment } from "@payezy/api-client/public";

type Tone = "success" | "info" | "warning" | "danger" | "neutral";

export function paymentTone(status: string): Tone {
  switch (status) {
    case "completed":
      return "success";
    case "failed":
    case "returned":
    case "canceled":
      return "danger";
    case "pending_approval":
    case "refunded":
      return "warning";
    default:
      return "info";
  }
}

const kinds: Record<string, string> = {
  fiat_deposit: "Bank deposit",
  crypto_deposit: "Stablecoin deposit",
  fiat_payout: "Bank transfer",
  crypto_payout: "Stablecoin transfer",
  book_transfer: "Internal transfer",
};

const rails: Record<string, string> = {
  ach_credit: "ACH",
  same_day_ach_credit: "Same-day ACH",
  wire: "Wire",
  fednow_credit: "FedNow",
  onchain: "On-chain",
  book: "Book",
};

export function paymentTitle(p: Payment): string {
  return kinds[p.kind] ?? p.kind.replace(/_/g, " ");
}

export function railName(rail: string): string {
  return rails[rail] ?? rail;
}

export const DEV_TOOLS = import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === "true";
